import type { GridStyle, ThemeColors } from "@platform/api";

export interface GridColorDef {
  key: keyof GridStyle;
  label: string;
  defaultHex: string;
}

export interface ThemeColorDef {
  key: keyof ThemeColors;
  label: string;
  defaultHex: string;
}

// Defaults mirror the Chameleon grid-style constants (OpenXmlGridStyleHelper);
// an empty field falls back to these, so they double as placeholder swatches.
export const GRID_STYLE_FIELDS: GridColorDef[] = [
  { key: "banner_fill", label: "Banner Fill", defaultHex: "F2F2F2" },
  { key: "header_fill", label: "Header Fill", defaultHex: "FFFFFF" },
  { key: "border_color", label: "Border", defaultHex: "D9D9D9" },
  { key: "positive_fill", label: "Positive Fill", defaultHex: "E8F5E9" },
  { key: "positive_text", label: "Positive Text", defaultHex: "1B5E20" },
  { key: "negative_fill", label: "Negative Fill", defaultHex: "FDECEA" },
  { key: "negative_text", label: "Negative Text", defaultHex: "B71C1C" },
];

// Placeholder swatches are the standard Office theme colors; an empty field
// keeps the template workbook's existing theme slot.
export const THEME_COLOR_FIELDS: ThemeColorDef[] = [
  { key: "dark1", label: "Text 1 (Dark)", defaultHex: "000000" },
  { key: "light1", label: "Background 1 (Light)", defaultHex: "FFFFFF" },
  { key: "dark2", label: "Text 2 (Dark)", defaultHex: "44546A" },
  { key: "light2", label: "Background 2 (Light)", defaultHex: "E7E6E6" },
  { key: "accent1", label: "Accent 1", defaultHex: "4472C4" },
  { key: "accent2", label: "Accent 2", defaultHex: "ED7D31" },
  { key: "accent3", label: "Accent 3", defaultHex: "A5A5A5" },
  { key: "accent4", label: "Accent 4", defaultHex: "FFC000" },
  { key: "accent5", label: "Accent 5", defaultHex: "5B9BD5" },
  { key: "accent6", label: "Accent 6", defaultHex: "70AD47" },
  { key: "hyperlink", label: "Hyperlink", defaultHex: "0563C1" },
  {
    key: "followed_hyperlink",
    label: "Followed Hyperlink",
    defaultHex: "954F72",
  },
];
